export default "__VITE_ASSET__Dj2093lg__"